import {
  Building2,
  Contact,
  Target,
  Users,
  CalendarDays,
  Download,
  FileText,
  FolderOpen,
  LayoutDashboard,
  MessageSquare,
  Phone,
  Receipt,
  Share2,
  TrendingUp,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface ClientNavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  end?: boolean;
  /** Reads the unread count from the dashboard payload. */
  badgeKey?: 'unreadMessages';
  /**
   * Which CRM area this entry needs, if any. The server decides whether it is
   * granted; this only names which answer to look at.
   */
  crmArea?: 'leads' | 'contacts' | 'companies' | 'deals';
}

/**
 * The client portal, in the order an owner uses it: what happened today, then
 * the detail behind it, then the paperwork.
 */
export const CLIENT_NAV: ClientNavItem[] = [
  { label: 'Dashboard', to: '/', icon: LayoutDashboard, end: true },
  { label: 'Reports', to: '/reports', icon: FileText },
  { label: 'Calls', to: '/calls', icon: Phone },
  { label: 'Appointments', to: '/appointments', icon: CalendarDays },
  { label: 'Pipeline', to: '/pipeline', icon: TrendingUp },
  /*
   * One entry per area, each appearing only when the agency has shared it —
   * the same way the employee sidebar hides what a person has not been
   * granted. A single "Records" link would have to be shown even when only
   * one of the four is on, and then explain itself.
   */
  { label: 'Leads', to: '/records/leads', icon: Users, crmArea: 'leads' },
  { label: 'Contacts', to: '/records/contacts', icon: Contact, crmArea: 'contacts' },
  { label: 'Companies', to: '/records/companies', icon: Building2, crmArea: 'companies' },
  { label: 'Opportunities', to: '/records/opportunities', icon: Target, crmArea: 'deals' },
  { label: 'Social', to: '/social', icon: Share2 },
  { label: 'Messages', to: '/messages', icon: MessageSquare, badgeKey: 'unreadMessages' },
  { label: 'Drive', to: '/files', icon: FolderOpen },
  { label: 'Invoices', to: '/invoices', icon: Receipt },
  { label: 'Downloads', to: '/downloads', icon: Download },
];
